import { isCrawler, mapIncomingHeadersToWebHeaders } from "@/proxy-utils"

import { SIGNED_IN_LANDING_PATH } from "@/lib/auth-utils"
import { MtSSP } from "@/lib/mt-server-side-props"
import {
  HERO_VIDEO_COUNT,
  Homepage,
  HomepageProps,
} from "@/components/marketing/homepage"

export default Homepage

export const getServerSideProps = MtSSP.asPublicPage<HomepageProps>({
  handler: async ({ context, redirectWithParams, baseProps }) => {
    const props = await baseProps()

    const headers = mapIncomingHeadersToWebHeaders(context.req.headers)
    const isUserCrawler = isCrawler(headers)

    if (props.session && !isUserCrawler) {
      return redirectWithParams(SIGNED_IN_LANDING_PATH)
    }

    return {
      props: {
        ...props,
        initialHeroIndex: Math.floor(Math.random() * HERO_VIDEO_COUNT),
      },
    }
  },
})
